import { Directive, DOCUMENT, inject, input } from '@angular/core';

@Directive({
  selector: '[appScrollTo]',
  host: {
    '(click)': 'onClick($event)',
  },
})
export class ScrollTo {
  private document = inject(DOCUMENT);

  scrollTo = input.required({ alias: 'appScrollTo' });

  onClick(event: Event) {
    event.preventDefault();

    const target = this.document.querySelector(
      `[scroll-target="${this.scrollTo()}"]`,
    );

    target?.scrollIntoView({ behavior: 'smooth' });
  }
}
